import './index.css';
import 'react-datepicker/dist/react-datepicker.css';

import * as React from 'react';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import Constants from 'src/common/Constants';
import Utility from 'src/common/Utility';
import Board from 'src/entities/Board';
import BoardItemEntity from 'src/entities/BoardItem';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import {
  createBoard,
  destroyBoard,
  readBoardsByGroup,
  updateBoard
} from '../../actions/board';
import CancelWhite from '../../res/img/cancel_white.svg';
import Profile from '../../res/img/member.svg';
import Next from '../../res/img/next.svg';
import PlusWhite from '../../res/img/plus_white.svg';
import Prev from '../../res/img/prev.svg';
import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import SwitchAdmin from '../Navigation/switchAdmin';
import BoardItem from './item';

const ConstantsLocal = {
  TASK: 1,
  ISSUE: 2,
  RISK: 3
};

interface IProps {
  group: Group;
  account: Member;
  boards: Board[];
  members: Member[];
  createBoard: (board: Board) => void;
  updateBoard: (board: Board) => void;
  destroyBoard: (board: Board) => void;
  readBoardsByGroup: (group: Group) => void;
}

interface IState {
  loadedApis: number[];
  board: Board;
  newBoard: Board;
  newTask: BoardItemEntity;
  newIssue: BoardItemEntity;
  newRisk: BoardItemEntity;
  isEditingNewBoard: boolean;
  isEditingBoard: number;
  editingBoard: Board;
  addItemFormShown: number[];
}

class BoardComponent extends React.Component<IProps, IState> {
  newBoardTitle: HTMLInputElement;
  editBoardTitle: HTMLInputElement;

  constructor(props: any) {
    super(props);
    this.state = {
      loadedApis: [],
      board: new Board(),
      newBoard: new Board(),
      isEditingNewBoard: false,
      isEditingBoard: 0,
      editingBoard: new Board(),
      addItemFormShown: [],
      newTask: new BoardItemEntity(),
      newIssue: new BoardItemEntity(),
      newRisk: new BoardItemEntity()
    };

    this.onChangeNewBoard = this.onChangeNewBoard.bind(this);
    this.onEditingNewBoard = this.onEditingNewBoard.bind(this);
    this.offEditingNewBoard = this.offEditingNewBoard.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.destroyItem = this.destroyItem.bind(this);
  }

  componentWillMount() {
    if (
      this.props.group !== undefined &&
      !this.state.loadedApis.includes(this.props.group.id)
    ) {
      this.setState({
        loadedApis: [...this.state.loadedApis, this.props.group.id]
      });
      this.props.readBoardsByGroup(this.props.group);
    }
  }

  componentDidUpdate() {
    const newBoard = this.props.boards.find(
      board => board.id === this.state.board.id
    );
    if (
      newBoard !== undefined &&
      this.state.board.updated !== newBoard.updated
    ) {
      this.setState({
        board: newBoard
      });
    }

    if (newBoard === undefined && this.state.board.id !== undefined) {
      this.setState({
        board: new Board()
      });
    }

    if (
      this.props.group !== undefined &&
      !this.state.loadedApis.includes(this.props.group.id)
    ) {
      this.setState({
        loadedApis: [...this.state.loadedApis, this.props.group.id]
      });
      this.props.readBoardsByGroup(this.props.group);
    }

    if (this.state.board.id === undefined && this.props.boards.length > 0) {
      this.setState({
        board: this.props.boards[0]
      });
    }
  }

  render() {
    if (this.props.group === undefined) {
      return null;
    }

    if (!this.props.group.functions.includes(Constants.FUNCTION_BOARD)) {
      return (
        <div id="BoardIndex">
          {this.renderHeader()}
          <div id="FunctionNotFound">
            ボード機能は本グループで無効になっています。
          </div>
        </div>
      );
    }

    const isWatcher = this.props.group.watchers.includes(this.props.account.id);

    return (
      <div id="BoardIndex">
        {this.renderHeader()}

        <div>
          <div id="Tabs">
            {this.props.boards
              .sort((a, b) => (a.orderInGroup > b.orderInGroup ? 1 : -1))
              .map(board => (
                <div
                  className={
                    this.state.board.id !== undefined &&
                    this.state.board.id === board.id
                      ? 'Tab TabSelected'
                      : 'Tab'
                  }
                >
                  {this.state.isEditingBoard !== board.id ? (
                    <div>
                      <span
                        className="Title"
                        onClick={this.selectBoard.bind(this, board)}
                        onDoubleClick={this.onEditingBoard.bind(this, board)}
                      >
                        {board.title}
                      </span>
                      <div
                        className="Prev"
                        onClick={this.reorderBoard.bind(this, board, 'prev')}
                      >
                        <img src={Prev} />
                      </div>
                      <div
                        className="Next"
                        onClick={this.reorderBoard.bind(this, board, 'next')}
                      >
                        <img src={Next} />
                      </div>
                    </div>
                  ) : (
                    <input
                      ref={text => {
                        this.editBoardTitle = text as HTMLInputElement;
                      }}
                      onBlur={this.offEditingBoard.bind(this, board)}
                      onChange={this.onChangeBoard.bind(this, board)}
                      className="InputText"
                      value={this.state.editingBoard.title}
                    />
                  )}
                </div>
              ))}

            {!isWatcher ? (
              <div
                className="Tab"
                id="AddBoard"
                onClick={this.onEditingNewBoard}
              >
                {!this.state.isEditingNewBoard ? (
                  <img src={PlusWhite} />
                ) : (
                  <input
                    ref={text => {
                      this.newBoardTitle = text as HTMLInputElement;
                    }}
                    onBlur={this.offEditingNewBoard}
                    onChange={this.onChangeNewBoard}
                    className="InputText"
                    value={this.state.newBoard.title}
                  />
                )}
              </div>
            ) : null}
          </div>

          {this.state.board.id !== undefined ? (
            <div id="Content">
              <div id="Tasks">
                <label>タスク</label>
                {this.state.board.items
                  .filter(
                    item => item.type === ConstantsLocal.TASK && !item.completed
                  )
                  .sort((a, b) => (a.deadline > b.deadline ? 1 : -1))
                  .map((item, i) => (
                    <BoardItem
                      key={i}
                      item={item}
                      updateItem={this.updateItem}
                      destroyItem={this.destroyItem}
                      account={this.props.account}
                      isWatcher={isWatcher}
                      members={this.props.members.filter(m =>
                        this.props.group.members.includes(m.id)
                      )}
                      member={
                        this.props.members.find(
                          member => member.id === item.memberId
                        ) as Member
                      }
                    />
                  ))}

                {!isWatcher ? (
                  <div>
                    {!this.state.addItemFormShown.includes(
                      ConstantsLocal.TASK
                    ) ? (
                      <div
                        className="AddItemContainer"
                        onClick={this.showAddItemForm.bind(
                          this,
                          ConstantsLocal.TASK
                        )}
                      >
                        <div className="AddItem">
                          <img src={PlusWhite} />
                        </div>
                      </div>
                    ) : (
                      this.renderAddItemForm(ConstantsLocal.TASK)
                    )}
                  </div>
                ) : null}

                {this.state.board.items.filter(
                  item => item.type === ConstantsLocal.TASK && item.completed
                ).length > 0 ? (
                  <div className="Border" />
                ) : null}

                {this.state.board.items
                  .filter(
                    item => item.type === ConstantsLocal.TASK && item.completed
                  )
                  .sort((a, b) => (a.deadline < b.deadline ? 1 : -1))
                  .map(item => (
                    <BoardItem
                      item={item}
                      updateItem={this.updateItem}
                      destroyItem={this.destroyItem}
                      account={this.props.account}
                      isWatcher={isWatcher}
                      members={this.props.members.filter(m =>
                        this.props.group.members.includes(m.id)
                      )}
                      member={
                        this.props.members.find(
                          member => member.id === item.memberId
                        ) as Member
                      }
                    />
                  ))}
              </div>
              <div id="Issues">
                <label>課題</label>
                {this.state.board.items
                  .filter(
                    item =>
                      item.type === ConstantsLocal.ISSUE && !item.completed
                  )
                  .sort((a, b) => (a.deadline > b.deadline ? 1 : -1))
                  .map(item => (
                    <BoardItem
                      item={item}
                      updateItem={this.updateItem}
                      destroyItem={this.destroyItem}
                      account={this.props.account}
                      isWatcher={isWatcher}
                      members={this.props.members.filter(m =>
                        this.props.group.members.includes(m.id)
                      )}
                      member={
                        this.props.members.find(
                          member => member.id === item.memberId
                        ) as Member
                      }
                    />
                  ))}

                {!isWatcher ? (
                  <div>
                    {!this.state.addItemFormShown.includes(
                      ConstantsLocal.ISSUE
                    ) ? (
                      <div
                        className="AddItemContainer"
                        onClick={this.showAddItemForm.bind(
                          this,
                          ConstantsLocal.ISSUE
                        )}
                      >
                        <div className="AddItem">
                          <img src={PlusWhite} />
                        </div>
                      </div>
                    ) : (
                      this.renderAddItemForm(ConstantsLocal.ISSUE)
                    )}
                  </div>
                ) : null}

                {this.state.board.items.filter(
                  item => item.type === ConstantsLocal.ISSUE && item.completed
                ).length > 0 ? (
                  <div className="Border" />
                ) : null}

                {this.state.board.items
                  .filter(
                    item => item.type === ConstantsLocal.ISSUE && item.completed
                  )
                  .sort((a, b) => (a.deadline < b.deadline ? 1 : -1))
                  .map(item => (
                    <BoardItem
                      item={item}
                      updateItem={this.updateItem}
                      destroyItem={this.destroyItem}
                      account={this.props.account}
                      isWatcher={isWatcher}
                      members={this.props.members.filter(m =>
                        this.props.group.members.includes(m.id)
                      )}
                      member={
                        this.props.members.find(
                          member => member.id === item.memberId
                        ) as Member
                      }
                    />
                  ))}
              </div>
              <div id="Risks">
                <label>リスク</label>
                {this.state.board.items
                  .filter(
                    item => item.type === ConstantsLocal.RISK && !item.completed
                  )
                  .sort((a, b) => (a.deadline > b.deadline ? 1 : -1))
                  .map(item => (
                    <BoardItem
                      item={item}
                      updateItem={this.updateItem}
                      destroyItem={this.destroyItem}
                      account={this.props.account}
                      isWatcher={isWatcher}
                      members={this.props.members.filter(m =>
                        this.props.group.members.includes(m.id)
                      )}
                      member={
                        this.props.members.find(
                          member => member.id === item.memberId
                        ) as Member
                      }
                    />
                  ))}

                {!isWatcher ? (
                  <div>
                    {!this.state.addItemFormShown.includes(
                      ConstantsLocal.RISK
                    ) ? (
                      <div
                        className="AddItemContainer"
                        onClick={this.showAddItemForm.bind(
                          this,
                          ConstantsLocal.RISK
                        )}
                      >
                        <div className="AddItem">
                          <img src={PlusWhite} />
                        </div>
                      </div>
                    ) : (
                      this.renderAddItemForm(ConstantsLocal.RISK)
                    )}
                  </div>
                ) : null}

                {this.state.board.items.filter(
                  item => item.type === ConstantsLocal.RISK && item.completed
                ).length > 0 ? (
                  <div className="Border" />
                ) : null}

                {this.state.board.items
                  .filter(
                    item => item.type === ConstantsLocal.RISK && item.completed
                  )
                  .sort((a, b) => (a.deadline < b.deadline ? 1 : -1))
                  .map(item => (
                    <BoardItem
                      item={item}
                      updateItem={this.updateItem}
                      destroyItem={this.destroyItem}
                      account={this.props.account}
                      isWatcher={isWatcher}
                      members={this.props.members.filter(m =>
                        this.props.group.members.includes(m.id)
                      )}
                      member={
                        this.props.members.find(
                          member => member.id === item.memberId
                        ) as Member
                      }
                    />
                  ))}
              </div>
            </div>
          ) : (
            <div id="Content" />
          )}
        </div>
      </div>
    );
  }

  renderHeader() {
    return (
      <div>
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="board" group={this.props.group} />

          {this.props.account.isSystemAdmin ||
          this.props.group.admins.includes(this.props.account.id) ? (
            <SwitchAdmin group={this.props.group} />
          ) : null}
        </div>
      </div>
    );
  }

  renderAddItemForm(type: number) {
    const item =
      type === ConstantsLocal.TASK
        ? this.state.newTask
        : type === ConstantsLocal.ISSUE
        ? this.state.newIssue
        : this.state.newRisk;

    return (
      <div className="AddItemForm">
        <div className="Cancel" onClick={this.hidAddItemForm.bind(this, type)}>
          <img src={CancelWhite} />
        </div>
        <div className="Member">
          <img
            src={
              this.props.account.profile !== null
                ? this.props.account.profile
                : Profile
            }
          />
          <span>{this.props.account.nameLast}</span>
        </div>
        <div className="Content">
          <textarea
            value={item.text}
            onChange={this.onChangeItemText.bind(this, type)}
          />
          <div className="ContentBottom">
            <DatePicker
              selected={new Date(item.deadline)}
              onChange={this.onChangeItemDeadline.bind(this, type)}
              dateFormat="MM月dd日"
            />

            {/* <input
              type="date"
              value={Utility.dateFormat(new Date(item.deadline), 'yyyy-MM-dd')}
              onChange={this.onChangeItemDeadline.bind(this, type)}
            /> */}
            <button className="Edit" onClick={this.createItem.bind(this, type)}>
              作成
            </button>
          </div>
        </div>
      </div>
    );
  }

  showAddItemForm(type: number, e: any) {
    this.setState({
      addItemFormShown: [...this.state.addItemFormShown, type]
    });
  }

  hidAddItemForm(type: number, e: any) {
    this.setState({
      addItemFormShown: this.state.addItemFormShown.filter(t => t !== type)
    });
  }

  selectBoard(board: Board, e: any) {
    this.setState({
      board,
      addItemFormShown: []
    });
  }

  onChangeNewBoard(e: any) {
    const newBoard = Object.assign({}, this.state.newBoard);
    newBoard.title = e.target.value;
    this.setState({
      newBoard
    });
  }

  onEditingNewBoard(e: any) {
    this.setState({
      isEditingNewBoard: true
    });
    setTimeout(() => {
      this.newBoardTitle.focus();
    }, 10);
  }

  offEditingNewBoard(e: any) {
    this.setState({
      isEditingNewBoard: false
    });

    const board = Object.assign({}, this.state.newBoard);
    if (board.title.length > 0) {
      board.created = Date.now();
      board.updated = Date.now();
      board.groupId = this.props.group.id;
      board.orderInGroup = this.props.boards.length + 1;

      this.props.createBoard(board);
      this.setState({
        newBoard: new Board()
      });
    }
  }

  onChangeBoard(board: Board, e: any) {
    board.title = e.target.value;
    this.setState({
      editingBoard: board
    });
  }

  onChangeItemText(type: number, e: any) {
    if (type === ConstantsLocal.TASK) {
      this.setState({
        newTask: {
          ...this.state.newTask,
          text: e.target.value
        }
      });
    } else if (type === ConstantsLocal.ISSUE) {
      this.setState({
        newIssue: {
          ...this.state.newIssue,
          text: e.target.value
        }
      });
    } else {
      this.setState({
        newRisk: {
          ...this.state.newRisk,
          text: e.target.value
        }
      });
    }
  }

  onChangeItemDeadline(type: number, date: any) {
    if (type === ConstantsLocal.TASK) {
      this.setState({
        newTask: {
          ...this.state.newTask,
          deadline: Date.parse(date)
        }
      });
    } else if (type === ConstantsLocal.ISSUE) {
      this.setState({
        newIssue: {
          ...this.state.newIssue,
          deadline: Date.parse(date)
        }
      });
    } else {
      this.setState({
        newRisk: {
          ...this.state.newRisk,
          deadline: Date.parse(date)
        }
      });
    }
  }

  createItem(type: number, e: any) {
    const board = Object.assign({}, this.state.board);
    let item: BoardItemEntity;
    if (type === ConstantsLocal.TASK) {
      item = this.state.newTask;
      this.setState({
        newTask: new BoardItemEntity()
      });
    } else if (type === ConstantsLocal.ISSUE) {
      item = this.state.newIssue;
      this.setState({
        newIssue: new BoardItemEntity()
      });
    } else {
      item = this.state.newRisk;
      this.setState({
        newRisk: new BoardItemEntity()
      });
    }
    item.created = Date.now();
    item.updated = Date.now();
    item.type = type;
    item.memberId = this.props.account.id;

    if (item.text.length > 0) {
      board.items.push(item);
      this.props.updateBoard(board);
      this.hidAddItemForm(type, null);
    }
  }

  onEditingBoard(board: Board, e: any) {
    this.setState({
      isEditingBoard: board.id,
      editingBoard: board
    });
    setTimeout(() => {
      this.editBoardTitle.focus();
    }, 10);
  }

  offEditingBoard(board: Board, e: any) {
    this.setState({
      isEditingBoard: 0
    });
    if (board.title.length > 0) {
      this.props.updateBoard(board);
    } else {
      if (
        this.props.group.admins.includes(this.props.account.id) &&
        confirm('このボードを削除してよろしいですか')
      ) {
        this.props.destroyBoard(board);
      }
    }
  }

  updateItem(item: BoardItemEntity) {
    const board = Object.assign({}, this.state.board);
    board.items = board.items.map(i => (i.created === item.created ? item : i));
    this.props.updateBoard(board);
  }
  destroyItem(item: BoardItemEntity) {
    const board = Object.assign({}, this.state.board);
    board.items = board.items.filter(i => i.created !== item.created);
    this.props.updateBoard(board);
  }

  reorderBoard(board: Board, order: string) {
    const boardCopy = Object.assign({}, board);
    let boardRelated: Board;
    if (order === 'prev') {
      boardCopy.orderInGroup -= 1;
      boardRelated = Object.assign({}, this.props.boards.find(
        b => b.orderInGroup === boardCopy.orderInGroup
      ) as Board);
      boardRelated.orderInGroup += 1;
    } else {
      boardCopy.orderInGroup += 1;
      boardRelated = Object.assign({}, this.props.boards.find(
        b => b.orderInGroup === boardCopy.orderInGroup
      ) as Board);
      boardRelated.orderInGroup -= 1;
    }
    this.props.updateBoard(boardCopy);
    this.props.updateBoard(boardRelated);
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  account: state.Account,
  members: state.Member,
  boards: state.Board.filter(
    (board: Board) =>
      board.groupId ===
      state.Group.find(
        (group: Group) => group.title === ownProps.match.params.group
      ).id
  ),
  t: Date.now()
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    createBoard(board: Board) {
      dispatch(createBoard(board));
    },
    updateBoard(board: Board) {
      dispatch(updateBoard(board));
    },
    destroyBoard(board: Board) {
      dispatch(destroyBoard(board));
    },
    readBoardsByGroup(group: Group) {
      dispatch(readBoardsByGroup(group));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BoardComponent);



// WEBPACK FOOTER //
// ./src/components/Board/index.tsx